import {
  capitalize,
  deepEquals,
  getElementDefinition,
  stringify,
  TypedValue,
} from '@medplum/core';
import {
  getCurrentAnswer,
  QuestionnaireChoiceInputProps,
} from '../QuestionnaireFormItem/QuestionnaireFormItem';
import {
  getItemAnswerOptionValue,
  getItemInitialValue,
  ResourcePropertyDisplay,
} from '@medplum/react';
import classes from './QuestionnaireChoiceRadioInput.module.css';
import { Group } from '@mantine/core';
import { ChangeEvent } from 'react';

function getCurrentRadioAnswer(
  options: [string, TypedValue][],
  defaultAnswer: TypedValue
): string | undefined {
  return options.find((option) =>
    deepEquals(option[1].value, defaultAnswer?.value)
  )?.[0];
}

export function QuestionnaireChoiceRadioInput(
  props: QuestionnaireChoiceInputProps
): JSX.Element {
  const { name, item, initial, onChangeAnswer, response } = props;
  const valueElementDefinition = getElementDefinition(
    'QuestionnaireItemAnswerOption',
    'value[x]'
  );
  const initialValue = getItemInitialValue(initial);

  const options: [string, TypedValue][] = [];
  let defaultValue = undefined;
  if (item.answerOption) {
    for (let i = 0; i < item.answerOption.length; i++) {
      const option = item.answerOption[i];
      const optionName = `${name}-option-${i}`;
      const optionValue = getItemAnswerOptionValue(option);

      if (!optionValue?.value) {
        continue;
      }

      if (initialValue && stringify(optionValue) === stringify(initialValue)) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        defaultValue = optionName;
      }
      options.push([optionName, optionValue]);
    }
  }

  const defaultAnswer = getCurrentAnswer(response);
  const answerLinkId = getCurrentRadioAnswer(options, defaultAnswer);

  return (
    <fieldset name={name} className={classes.fieldsetTransparent}>
      {options.map(([optionName, optionValue]) => (
        <Group key={optionName} gap="xs" wrap="nowrap">
          <input
            id={optionName}
            value={optionName}
            type="radio"
            name={name}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              const newValue = event.currentTarget.value;
              const option = options.find((item) => item[0] === newValue);
              if (option) {
                const optionValue = option[1];
                const propertyName = 'value' + capitalize(optionValue.type);
                onChangeAnswer({ [propertyName]: optionValue.value });
              }
            }}
            checked={answerLinkId === optionName}
            required
          />
          <ResourcePropertyDisplay
            property={valueElementDefinition}
            propertyType={optionValue.type}
            value={optionValue.value}
          />
        </Group>
      ))}
    </fieldset>
  );
}
